
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Auth } from 'src/app/models/auth';
import { DadoBancarioCedente } from 'src/app/models/dado-bancario-cedente';
import { DadoBancarioService } from 'src/app/services/dado-bancario.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { TransactionService } from 'src/app/services/transaction.service';
import { SolicitacoesRequestModel } from 'src/app/models/request/solicitacoes-request-model';
import { SolicitacoesResponseModel } from 'src/app/models/response/solicitacoes-response-model';
import { IntencaoDepositoRequestModel } from 'src/app/models/request/intencao-deposito-request-model';
import { IntencaoDepositoResponseModel } from 'src/app/models/response/intencao-deposito-response-model';
import { IntencaoConsultaResponseModel } from 'src/app/models/response/intencao-consulta-response-model';
import { IntencaoConsultaRequestModel } from 'src/app/models/request/intencao-consulta-request-model';
import { TipoDepositoEnum } from 'src/app/shared/enums/tipo-deposito-enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { MASKS } from 'ng-brazil';
import { DepositoService } from 'src/app/services/deposito.service';
import { IntencaoDepositoDetalhes } from 'src/app/models/intencao-deposito-detalhes';
import { UploadComprovanteRequestModel } from 'src/app/models/request/upload-comprovante-request-model';
import { GerarPixDinamico } from 'src/app/models/request/gerar-pix-dinamico';
import { CedenteService } from 'src/app/services/cedente.service';
import { environment } from 'src/environments/environment';
import { QRCodePixDinamico } from 'src/app/models/response/pix-qrcode';
import { DepositoViaPIXRequestModel } from 'src/app/models/request/deposito-via-boleto-request-model';
import { BRCodePix } from 'src/app/models/response/brcode-pix';
import { CardNameBroadcastServiceService } from 'src/app/services/card-name-broadcast-service.service';
import { Assignor } from 'src/app/models/assignor';

@Component({
  selector: 'app-transferencia',
  templateUrl: './transferencia.component.html',
  styleUrls: ['./transferencia.component.css']
})
export class TransferenciaComponent implements OnInit {

  public currentUser: Auth;
  public dadosBancarios: DadoBancarioCedente[] = [];
  public solicitacoes: SolicitacoesResponseModel[] = [];
  public message = '';
  public confirmacaoDeposito: IntencaoDepositoResponseModel = null;
  public informativoDeposito = new IntencaoConsultaResponseModel();
  public dadosParaTransferencia = new IntencaoDepositoResponseModel();
  public MASKS = MASKS;
  public sortOrder: boolean;
  public intencaoDepositoDetalhes: IntencaoDepositoDetalhes = null;
  private uploadComprovanteRequestModel = new UploadComprovanteRequestModel();
  protected depositoSelecionadoId: string;
  protected btnEnviarEnable: boolean = false;
  public depositoPixRequest: GerarPixDinamico;
  public assignorInfo: Assignor;
  public qrCodePix: QRCodePixDinamico;
  public brCodePix: BRCodePix;
  public valorQRCode: number;
  public nomeEmpresa: string;

  @ViewChild('modalDadosParaTransferencia', { static: true }) modalDadosParaTransferencia: TemplateRef<any>;

  constructor(
    private transactionservice: TransactionService,
    private dadoBancarioService: DadoBancarioService,
    private authenticationService: AuthenticationService,
    private cardNameBroadcastServiceService: CardNameBroadcastServiceService,
    private cedenteService: CedenteService,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    private depositoService: DepositoService,
    private transactionService: TransactionService
  ) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    //console.log(this.nomeEmpresa);

    this.qrCodePix = new QRCodePixDinamico();
    this.loadInfo();
    this.BuscarSolicitacoes();

    this.message = '';
  }
  private loadInfo() {
    this.cedenteService.getAssignorInfo(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        this.assignorInfo = response.result;

        const tam = environment.TOTAL_CARACTERE_CNPJ - this.assignorInfo.document.toString().length;

        let str = this.assignorInfo.document.toString();

        for (let i = 0; i < tam; i++) { str = '0' + str; }
        this.assignorInfo.document = str;
      }, error => {
        this.alertService.error('Ocorreu um erro ao consultar as informações da empresa. Tente novamente mais tarde');
      }
    );


  }

  private BuscarDadosBancarios() {
    this.dadoBancarioService.getAll(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.dadosBancarios = response.result;
        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
      }
    );
  }

  private BuscarSolicitacoes() {
    const solicitacoesRequestModel = new SolicitacoesRequestModel();
    solicitacoesRequestModel.ContaId = this.currentUser.token.accountId;
    solicitacoesRequestModel.Cancelados = false;
    solicitacoesRequestModel.Processados = false;
    solicitacoesRequestModel.SolicitacaoSemDetalhamento = true;
    solicitacoesRequestModel.SolicitacaoSemPedido = false;
    solicitacoesRequestModel.TipoDeposito = TipoDepositoEnum.PIX;
    solicitacoesRequestModel.TipoSolicitacao = 'D';

    this.transactionservice.BuscarSolicitacoes(solicitacoesRequestModel).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.solicitacoes = response.result;
          //console.log(this.solicitacoes);
          this.orderBy('solicitacaoId', true);
        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
      }
    );
  }


  public DepositarViaTransferencia(valor: string, bancoID: string) {
    let formValid = true;
    valor = valor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();

    if (!valor || +valor == 0) {
      this.message = 'Preencha o valor';
      formValid = false;
    }

    if (formValid) {
      const intencaoDepositoRequestModel = new IntencaoDepositoRequestModel();
      intencaoDepositoRequestModel.contaId = this.currentUser.token.accountId;
      intencaoDepositoRequestModel.bancoOrigemId = bancoID;
      intencaoDepositoRequestModel.valor = +valor;
      this.valorQRCode = +valor;

      this.dadosParaTransferencia = new IntencaoDepositoResponseModel();

      this.transactionservice.CriarDeposito(intencaoDepositoRequestModel).subscribe(
        response => {
          if (response.status === ApiError.Sucesso) {
            this.dadosParaTransferencia = response.result;
            this.AbrirModalDadosParaTransferencia(this.modalDadosParaTransferencia);
            this.BuscarSolicitacoes();

            const options = {
              keepAfterRouteChange: true
            };

            this.alertService.notificationInfo('Intenção de depósito', 'Registrada com sucesso, assim que a transferência for identificada vamos creditar o valor na conta da cedente. Obrigado!', options);
          } else {
            this.alertService.error(response.message);
          }
        },
        error => {
          this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
        }
      );
    }
  }



  public CancelarDeposito(depositoID: string) {
    this.transactionservice.CancelarDeposito(depositoID, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.alertService.success('Intenção de depósito cancelada com sucesso');
          this.BuscarSolicitacoes();
        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
      }
    );
  }

  showVisualizarIntencaoDeposito(content: any, intencaoDepositoGuid: string) {
    // chamar api
    this.depositoService.getDetails(intencaoDepositoGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.intencaoDepositoDetalhes = response.result;
          this.modalService.open(content, { centered: true, size: 'lg' });
        } else {
          this.alertService.error(response.message);
        }
      }, error => {
        this.alertService.error('Ocorreu um erro ao visualizar intenção de depósito');
      }
    );
  }

  depositarViaPix(content, valor) {

    let formValid = true;


    const depositoPixRequest = new GerarPixDinamico();
    depositoPixRequest.cnpjCedente = this.assignorInfo.document;
    valor = valor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
    if (!valor || +valor == 0) {
      this.message = 'Preencha o valor';
      formValid = false;
    }

    if(formValid){
      this.modalService.open(content, { centered: true, size: 'xl' });

    const depositoViaPIXRequestModel = new DepositoViaPIXRequestModel();
    depositoViaPIXRequestModel.contaGuid = this.currentUser.token.accountId;
    depositoViaPIXRequestModel.valor = +valor;
    depositoViaPIXRequestModel.cedenteGuid = this.currentUser.token.assignorGuid;
    depositoViaPIXRequestModel.gestorGuid = this.currentUser.token.userReferenceId;
    depositoPixRequest.valor = valor;
    this.valorQRCode = +valor;
    depositoPixRequest.nomeCedente = this.assignorInfo.nickName;
    depositoPixRequest.cedenteGuid = this.currentUser.token.assignorGuid;
    /* console.log(depositoPixRequest) */

    this.transactionservice.CriarDepositoViaPix(depositoViaPIXRequestModel).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          /* console.log(response) */
          depositoPixRequest.numeroPedido = response.result;
          /* console.log(depositoPixRequest) */
          this.gerarQRCodePIX(depositoPixRequest);

        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
      }
    );
  }else{
    this.alertService.error(this.message)
  }
  }

 gerarQRCodePIX(depositoPixRequest: GerarPixDinamico){
  this.transactionService.GerarPixDinamico(depositoPixRequest).subscribe(
    response => {
      if (response.status === ApiError.Sucesso) {
        /* console.log(response) */


        this.qrCodePix = response.result;

        /* console.log(this.qrCodePix) */
      } else {
        this.alertService.error(response.message);
      }
    }, error => {
      this.alertService.error('Ocorreu um erro ao visualizar intenção de depósito');
    }
  );
  }



  public AbrirModalDadosParaTransferencia(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }


  orderBy(collumnName: string, sortOrder: boolean) {
    this.solicitacoes.sort((a, b) => {
      const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
      const aVal = (a[collumnName] === null
        ? dftl
        : a[collumnName]
      ).toString();
      const bVal = (b[collumnName] === null
        ? dftl
        : b[collumnName]
      ).toString();
      let result = aVal.localeCompare(bVal, undefined, { numeric: true });
      if (sortOrder) {
        result = bVal.localeCompare(aVal, undefined, { numeric: true });
      }

      return result;
    });
  }

  showQRCodePagar(content: any, intencaoDepositoId: string, brCodePix: BRCodePix) {
    this.depositoSelecionadoId = intencaoDepositoId;
    this.brCodePix = new BRCodePix();
    this.brCodePix = brCodePix;
    /* console.log(brCodePix) */

    this.btnEnviarEnable = false;
    this.modalService.open(content, { centered: true, size: 'xl' });
  }

  upload(event: any) {
    const file = event.target.files[0];

    this.uploadComprovanteRequestModel.extensao = file.type.split('/')[1];
    this.uploadComprovanteRequestModel.mimeType = file.type;
    this.uploadComprovanteRequestModel.contaId = this.currentUser.token.accountId;
    this.uploadComprovanteRequestModel.depositoId = this.depositoSelecionadoId;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.btnEnviarEnable = true;
      this.uploadComprovanteRequestModel.imagemArray = reader.result.toString().split(',')[1];
    };
  }

  enviarComprovante() {
    this.transactionService.UploadComprovanteDeposito(this.uploadComprovanteRequestModel).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.alertService.success('Comprovante enviado com sucesso');
        } else {
          this.alertService.warning(response.message);
        }
      }, error => {
        this.alertService.error('Ocorreu um erro ao tentar enviar o comprovante');
      }
    )

    this.modalService.dismissAll();
  }

}
